import { defineStore } from 'pinia';

import {
  AccountSettingResponse,
  SystemSettingRepository,
} from '@/repositories/generated';

type AccountSettingState = {
  accountSetting?: AccountSettingResponse;
};

export const useAccountSettingStore = defineStore('accountSetting', {
  state: (): AccountSettingState => ({
    accountSetting: undefined,
  }),
  actions: {
    async getAccountSetting(): Promise<AccountSettingResponse> {
      if (this.accountSetting) {
        return this.accountSetting;
      }

      this.accountSetting = await SystemSettingRepository.setting();

      return this.accountSetting;
    },
  },
});
